/** *********************************************************
 * NOTE: This file should not be added to and any           *
 * new functionality should be put in `./Product.utils.ts`. *
 ********************************************************** */

/**
 * Helper function which recursively generates a nested map structure of variants for fast access.
 * @param {Object} variant A product variant
 * @param {array} sizes List of all variant sizes
 * @param {map} resultMap A base map to add values into
 * @returns {map|variant}
 */
export const generateChildMap = (variant, sizes, resultMap) => {
  const sizeCopy = [...sizes];
  if (!sizeCopy || !sizeCopy.length) return variant;
  const currentSize = sizeCopy.shift();
  const existingMap = resultMap.get(currentSize.id) || new Map();

  return resultMap.set(
    currentSize.id,
    generateChildMap(variant, sizeCopy, existingMap)
  );
};

/**
 * To support a transient state as content models are migrated, this function maps (soon to be) deprecated field values to updated component field values
 * When the migration is done, this can be deleted
 */
export const mapOldFieldsToNewComponentValues = (module) => {
  const additionalProps = {};

  if (module.__typename === 'ContentBlock') {
    additionalProps.imagePosition =
      module.imagePosition?.toUpperCase() || 'LEFT';

    if (module.image) {
      additionalProps.desktopImage = module.desktopImage || module.image;
      additionalProps.tabletImage = module.tabletImage || module.image;
      additionalProps.mobileImage = module.mobileImage || module.image;
    }

    if (module.imageStyle) {
      if (module.imageStyle === 'INSET') {
        additionalProps.verticalSpacing = module.verticalSpacing || 'compact';
      }

      if (module.imageStyle === 'BLEED') {
        additionalProps.verticalSpacing = module.verticalSpacing || 'none';
      }
    }

    if (module.content) {
      additionalProps.richText = module.richText || module.content;
    }
  }

  if (module.__typename === 'CardContainer') {
    switch (module.cardWidth) {
      case 'L':
        additionalProps.layoutDesktop = module.layoutDesktop || '3 across';
        additionalProps.layoutTablet = module.layoutTablet || '3 across';
        additionalProps.layoutMobile = module.layoutMobile || '1 across';
        break;
      default:
        break;
    }
  }

  return additionalProps;
};

export default {};
